import React from "react";
import useSWR from "swr";
import api, { money, fmtDate } from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import StatusBadge from "@/components/StatusBadge";

const fetcher = (u) => api.get(u).then((r) => r.data);

export default function Itinerary() {
  const { data: tours } = useSWR("/tours", fetcher);
  const [selTour, setSelTour] = React.useState("");
  const { data } = useSWR(selTour ? `/itinerary?tour_id=${selTour}` : null, fetcher);
  React.useEffect(() => { if (tours && !selTour && tours[0]) setSelTour(tours[0].id); }, [tours, selTour]);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div><h1 className="text-3xl sm:text-4xl font-bold tracking-tight">Itinerario</h1><p className="text-slate-500 mt-1">Días, actividades, kilómetros y horarios.</p></div>
        <select value={selTour} onChange={(e) => setSelTour(e.target.value)} className="border rounded-md px-3 py-2 text-sm bg-white dark:bg-[#131B2A] dark:border-[#25334D]">
          {(tours || []).map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
        </select>
      </div>
      <div className="space-y-3">
        {(data || []).sort((a,b) => a.day_number - b.day_number).map((d) => (
          <Card key={d.id}><CardContent className="p-5">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-lg bg-[#026FCB] text-white flex items-center justify-center font-bold mono">D{d.day_number}</div>
              <div className="flex-1">
                <div className="font-semibold">{d.from_place} → {d.to_place}</div>
                <div className="text-xs mono text-slate-500">{fmtDate(d.date)} · {d.kilometers} km · {d.driving_hours} h · ☀ {d.sunrise} · 🌇 {d.sunset}</div>
              </div>
            </div>
            <div className="mt-3 grid md:grid-cols-2 gap-4 text-sm">
              <div><div className="text-xs mono uppercase text-slate-500 mb-1">Actividades</div><ul className="list-disc pl-5 space-y-0.5">{(d.activities || []).map((a, i) => <li key={i}>{a}</li>)}</ul></div>
              <div><div className="text-xs mono uppercase text-slate-500 mb-1">Localizaciones</div><ul className="list-disc pl-5 space-y-0.5">{(d.photo_locations || []).map((l, i) => <li key={i}>{l}</li>)}</ul></div>
            </div>
            {d.guide_notes && <div className="mt-3 text-sm p-3 rounded-lg bg-sky-50 dark:bg-sky-950/40 text-sky-800 dark:text-sky-300"><span className="mono text-xs uppercase mr-2">Notas guía</span>{d.guide_notes}</div>}
          </CardContent></Card>
        ))}
        {(!data || data.length === 0) && <Card><CardContent className="p-10 text-center text-slate-500">Este tour aún no tiene itinerario.</CardContent></Card>}
      </div>
    </div>
  );
}
